function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#BFB7B6",
  d: "M6.968 7.905A1 1 0 118.331 9.37c-1.724 1.605-1.912 2.628-.923 3.552.97.908 2.26.514 4.19-1.637 2.272-2.687 4.605-3.367 6.63-1.635 2.008 1.716 1.818 3.996-.316 6.36a1 1 0 11-1.484-1.342c1.453-1.608 1.536-2.613.501-3.498-1.016-.87-2.162-.535-3.823 1.428-2.599 2.898-5.067 3.652-7.064 1.785-1.979-1.85-1.55-4.17.926-6.477zM14.5 21a2.5 2.5 0 110-5 2.5 2.5 0 010 5zM12.668 4.135l-1.55 4.648a.5.5 0 01-.827.195L7.192 5.88a.5.5 0 01.196-.828l4.648-1.55a.5.5 0 01.632.633z"
});

function SvgRoad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgRoad;